
export default {
    /** 地图搜索服务 */
    RestWPSSService: {
        name: egis.ews.RestWPSSService,
    },
    /** 地理编码服务 */
    RestWRGSService: {
        name: egis.ews.RestWRGSService,
    },
    /** IP定位 */
    RestWILSService: {
        name: egis.ews.RestWILSService,
    },
    /** 路径规划服务 */
    RestWRPSService: {
        name: egis.ews.RestWRPSService,
    },
    /** 倾斜摄影服务 */
    RestWOPSService: {
        name: egis.ews.RestWOPSService,
    },
};
